var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"message-banner",attrs:{"show":_vm.thisShowBanner,"variant":_vm.variant,"dismissible":""},on:{"dismissed":function($event){_vm.thisShowBanner=false}}},[_c('span',{staticClass:"span-login-page"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }